import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Contact } from '../../../sic-lib/types/Contact';
import ContactDetails from '../ContactDetails/ContactDetails';
import DialogConfirmDeleteContact from '../DialogConfirmDeleteContact/DialogConfirmDeleteContact';
import DialogModifyContactName from './DialogModifyContactName/DialogModifyContactName';

const useStyles = makeStyles()((theme: Theme) => ({
    btnCancel: {
        color: theme.palette.btnDefault.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
        },
    },
}));

interface Props {
    isOpen: boolean;
    contact: Contact;
    onDoneHandler: () => void;
}

export default function DialogModifyContactField({ isOpen, contact, onDoneHandler }: Props) {
    const { classes } = useStyles();

    const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

    const handleCancel = (event: React.MouseEvent<HTMLButtonElement>, reason?: string) => {
        if (!reason || (reason !== 'backdropClick' && reason !== 'escapeKeyDown')) {
            onDoneHandler();
        }
    };

    const handleDelete = (event: React.MouseEvent<HTMLButtonElement>, reason?: string) => {
        setConfirmDelete(true);
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleCancel}
            maxWidth="xs"
            aria-labelledby="dialog_confirm_action"
        >
            <DialogTitle id="dialog_confirm_action">Contact Info</DialogTitle>
            <DialogContent dividers>
                <DialogModifyContactName contact={contact} />
                <ContactDetails contact={contact} />
            </DialogContent>
            <DialogActions>
                <Button
                    className={classes.btnCancel}
                    onClick={handleCancel}
                    variant="text"
                    autoFocus
                >
                    Cancel
                </Button>
                <Button color="secondary" onClick={handleDelete} variant="outlined">
                    Delete Contact
                </Button>
                {confirmDelete && (
                    <DialogConfirmDeleteContact
                        isOpen={confirmDelete}
                        contactId={contact.contactId}
                        onDoneHandler={onDoneHandler}
                    />
                )}
                {/*<ButtonLoading
                    showLoading={requestStatus === RequestStatus.active}
                    onClick={handleConfirm}
                    color='secondary'
                    variant='outlined'
                >
                    Ok
                </ButtonLoading>*/}
            </DialogActions>
        </Dialog>
    );
}
